import { Box } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { useLogger } from '@hooks';
import { Routes, integratedSolutionFlowPath, subscriptionFlowPath } from '@navigation';
import { useNavigationStore, useNavigationStep } from '@store';
import React, { useCallback, useEffect, useState } from 'react';
import { WizardMenuItem } from './wizardMenuItem';

export interface WizardItem {
	title: string;
	children?: WizardItem[];
	route?: Routes;
}

interface WizardMenuProps {
	items: WizardItem[];
}

export const WizardMenu: React.FC<WizardMenuProps> = ({ items }) => {
	const logger = useLogger();
	const { current } = useNavigationStep();
	const { flow } = useNavigationStore();
	const [selectedIndex, setSelectedIndex] = useState<number>(-1);

	const findSelectedIndex = useCallback(
		(currentRoute: string) => {
			let index = subscriptionFlowPath.findIndex((route) => route === currentRoute);
			if (flow === 'integratedSolution') {
				index = integratedSolutionFlowPath.findIndex((route) => route === currentRoute);
			}
			setSelectedIndex(index);
		},
		[flow]
	);

	const totalChildrenCount = (index: number) => {
		return items.reduce((acc, item, idx): number => {
			if (idx < index) {
				acc = (item.children?.length || 0) + acc;
			}
			return acc;
		}, 0);
	};

	const totalParentWithChildrenCount = (index: number) => {
		return items.filter((item, idx) => idx < index && !!item.children?.length).length;
	};

	useEffect(() => {
		findSelectedIndex(current);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [current, selectedIndex, flow]);

	logger('WizardMenu > render');

	return (
		<Box styles={{ display: 'flex', flexDirection: 'column' }}>
			{items.map((item, parentIndex) => (
				<WizardMenuItem
					key={`wizard-menu-${parentIndex}`}
					item={item}
					parentIndex={parentIndex}
					selectedIndex={selectedIndex}
					totalChildrenCount={totalChildrenCount(parentIndex)}
					totalParentWithChildrenCount={totalParentWithChildrenCount(parentIndex)}
				/>
			))}
		</Box>
	);
};
